import { AnalyticsContext } from '@carvana/eventable-clickstream';
import Tooltip from '@carvana/showroom-tooltip';
import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import Tag from '@/SearchResults/ResultTile/Tags/Tag';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useVehicleContext } from '~/contexts/VehicleContext';
import usePriceDrop from '~/hooks/usePriceDrop';
import { ViewAllButton } from './Tags.style';

const NewPriceTag = () => {
  const { vehicle } = useVehicleContext();
  const { restrictedState, getPriceDrop } = usePriceDrop();
  const { priceDrop } = getPriceDrop(vehicle);
  const { trackEvent } = useContext(AnalyticsContext);
  const { setAppliedFilters } = useContext(AppliedFiltersContext);

  return (
    <Tooltip
      direction="bottom-start"
      display={{
        width: 178
      }}
      content={
        <>
          <div className="t-body-s text-grey-2">
            {restrictedState
              ? 'We are always repricing our inventory to make room for new vehicles. Don’t miss out!'
              : `We lowered our price by $${priceDrop.toLocaleString()} to make room for new inventory. Don’t miss out on the savings!`}
          </div>

          <Clickable
            className="mt-16 w-full"
            data-analytics-id={null}
            element={ViewAllButton}
            onClick={e => {
              e.preventDefault();
              trackEvent('Clicked New Price ToolTip CTA');
              setAppliedFilters({ tagIds: ['103'] });
            }}
          >
            Shop New Prices
          </Clickable>
        </>
      }
      title="New Price"
    >
      <div
        data-analytics-id="New Price Tooltip"
        onClick={e => e.preventDefault()}
      >
        <Tag text="New Price" bgColor="bg-green-2" data-qa="new-price-badge" />
      </div>
    </Tooltip>
  );
};

export default NewPriceTag;
